import React from 'react'

import PropTypes from 'prop-types';
import {Link as RouterLink} from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar } from '@material-ui/core';



const useStyles = makeStyles(theme => ({
    flexGrow: {
        flexGrow: 1
    },
    logoImg:{
        height: 45
    }
}))

function Header(props) {
    const { className, ...rest } = props;
    const classes = useStyles()

    return (
        // <div

        // >
        //     Header
        // </div>

        <AppBar position="fixed">
            <Toolbar>
               
                <RouterLink to="/">
                    <img 
                    src="/images/logos/drakto-5.svg" 
                    alt="Logo" 
                    className={classes.logoImg}/>
                </RouterLink>

                <div className={classes.flexGrow}></div>
               
            </Toolbar>
        </AppBar>
    )
}

export default Header
Header.propTypes={
    className: PropTypes.string
}